import {AccountSortField as AccountSortFields} from 'src/openapi/admin/models/AccountSortField';

import {COLUMNS, LOADING_PRIORITY} from './constants';

import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const checkShouldLoadColumn = (columnId: string, selectedColumns: string[]) => {
    const relation = LOADING_PRIORITY.find(rel => rel.columnId === columnId);
    if (!relation) {
        return false;
    }

    return !LOADING_PRIORITY
        .filter(column => selectedColumns.includes(column.columnId))
        .some(other => (
            other.columnId !== columnId &&
            other.chunk === relation.chunk &&
            other.priority > relation.priority
        ));
};

export const mapColumnIdToAccountSortField: (columnId: string) => AccountSortField = columnId => {
    switch (columnId) {
        case COLUMNS.ACCOUNT_NAME:
            return AccountSortFields.ACCOUNT_NAME;
        case COLUMNS.ACCOUNT_SEARCH_ID:
            return AccountSortFields.ACCOUNT_ID;
        case COLUMNS.ACCOUNT_STATUS:
            return AccountSortFields.ACCOUNT_STATUS;
        case COLUMNS.PARENT_ACCOUNT_NAME:
            return AccountSortFields.PARENT_ACCOUNT_NAME;
        case COLUMNS.SALESFORCE_INTEGRATION:
            return AccountSortFields.SALESFORCE_INTEGRATION;
        case COLUMNS.MS_DYNAMICS_INTEGRATION:
            return AccountSortFields.MS_DYNAMICS_INTEGRATION;
        case COLUMNS.DEAL_CLOUD_INTEGRATION:
            return AccountSortFields.DEAL_CLOUD_INTEGRATION;
        case COLUMNS.HUBSPOT_INTEGRATION:
            return AccountSortFields.HUBSPOT_INTEGRATION;
        case COLUMNS.PRIMARY_ACCOUNT_MANAGER:
            return AccountSortFields.PRIMARY_ACCOUNT_MANAGER;
        case COLUMNS.LICENSE_TYPE:
            return AccountSortFields.LICENSE_TYPE;
        case COLUMNS.LICENSE_END_DATE:
            return AccountSortFields.LICENSE_END_DATE;
        case COLUMNS.LICENSE_START_DATE:
            return AccountSortFields.LICENSE_START_DATE;
        case COLUMNS.ENTITY_TYPE:
            return AccountSortFields.ENTITY_TYPE;
        case COLUMNS.ACCOUNT_COUNTRY:
            return AccountSortFields.COUNTRY;
        case COLUMNS.IS_ACCOUNT_DELETED:
            return AccountSortFields.IS_DELETED;
        case COLUMNS.LICENSE_SEATS:
            return AccountSortFields.SEATS;
        case COLUMNS.SSO_ENABLED:
            return AccountSortFields.SSO_ENABLED;
        case COLUMNS.SSO_MANDATORY:
            return AccountSortFields.SSO_MANDATORY;
        default:
            return AccountSortFields.ACCOUNT_NAME;
    }
};
